var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-480 -466.815 2160 2160",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 613.185,
    r: 1080
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M306.615 79.694H144.011L892.476 1150.3h162.604zM0 0h357.328l309.814 450.883L1055.03 0h105.86L714.15 519.295 1200 1226.37H842.672L515.493 750.215 105.866 1226.37H0l468.485-544.568z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00ODAgLTQ2Ni44MTUgMjE2MCAyMTYwIj48Y2lyY2xlIGN4PSI2MDAiIGN5PSI2MTMuMTg1IiByPSIxMDgwIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTMwNi42MTUgNzkuNjk0SDE0NC4wMTFMODkyLjQ3NiAxMTUwLjNoMTYyLjYwNFpNMCAwaDM1Ny4zMjhsMzA5LjgxNCA0NTAuODgzTDEwNTUuMDMgMGgxMDUuODZMNzE0LjE1IDUxOS4yOTUgMTIwMCAxMjI2LjM3SDg0Mi42NzJMNTE1LjQ5MyA3NTAuMjE1IDEwNS44NjYgMTIyNi4zN0gwbDQ2OC40ODUtNTQ0LjU2OFoiLz48L3N2Zz4=";
export { SvgX as ReactComponent };